module.exports = {"data":{"site":{"siteMetadata":{"shortName":"Acclimate","longName":"Acclimate Consulting"}},"topImage":null},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 403
// module chunks = 142629428675168